import { ref, computed } from 'vue'

/**
 * Composable for managing product data
 * @returns {Object} Products data and utilities
 */
export function useProducts() {
    /**
     * @typedef {Object} Product
     * @property {number} id - Unique product identifier
     * @property {string} title - Product name
     * @property {string} category - Product category
     * @property {string} image - Product image URL
     * @property {string} description - Product description
     */

    /** @type {import('vue').Ref<Product[]>} */
    const products = ref([
        {
            id: 1,
            title: 'عقد ذهبي ملكي',
            category: 'عقود',
            image: 'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=800&q=80',
            description: 'عقد ذهبي عيار 24 قيراط بتصميم معقد، مثالي للمناسبات الخاصة.'
        },
        {
            id: 2,
            title: 'سوار ذهبي بالماس',
            category: 'أساور',
            image: 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=800&q=80',
            description: 'سوار أنيق مرصع بالماس الفاخر في ذهب خالص.'
        },
        {
            id: 3,
            title: 'خاتم ذهبي فاخر',
            category: 'خواتم',
            image: 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=800&q=80',
            description: 'خاتم ذهبي خالد بحرفية استثنائية ولمسة نهائية رائعة.'
        },
        {
            id: 4,
            title: 'ساعة ذهبية فاخرة',
            category: 'ساعات',
            image: 'https://images.unsplash.com/photo-1587836374828-4dbafa94cf0e?w=800&q=80',
            description: 'ساعة ذهبية راقية تجمع بين الفخامة والدقة في ضبط الوقت.'
        },
        {
            id: 5,
            title: 'سلسلة ذهبية كلاسيكية',
            category: 'عقود',
            image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=800&q=80',
            description: 'سلسلة ذهبية كلاسيكية، قطعة متعددة الاستخدامات لأي خزانة ملابس.'
        },
        {
            id: 6,
            title: 'سوار ذهبي بالزمرد',
            category: 'أساور',
            image: 'https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=800&q=80',
            description: 'سوار مذهل مزين بالزمرد ومصنوع من الذهب الخالص.'
        },
        {
            id: 7,
            title: 'خاتم زفاف ذهبي',
            category: 'خواتم',
            image: 'https://images.unsplash.com/photo-1603561591411-07134e71a2a9?w=800&q=80',
            description: 'خاتم زفاف جميل يرمز للحب والالتزام الأبدي.'
        },
        {
            id: 8,
            title: 'ساعة ذهبية مصممة',
            category: 'ساعات',
            image: 'https://images.unsplash.com/photo-1523170335258-f5ed11844a49?w=800&q=80',
            description: 'ساعة مصممة بلمسات ذهبية وحركة سويسرية فاخرة.'
        }
    ])

    /**
     * Get products by category
     * @param {string} category - Category to filter by
     * @returns {import('vue').ComputedRef<Product[]>}
     */
    const getProductsByCategory = (category) => {
        return computed(() =>
            products.value.filter(product => product.category === category)
        )
    }

    /**
     * Get all unique categories
     * @returns {import('vue').ComputedRef<string[]>}
     */
    const categories = computed(() => {
        return [...new Set(products.value.map(product => product.category))]
    })

    return {
        products,
        categories,
        getProductsByCategory
    }
}
